<template>
  <div class="bio-link-simple" :style="{color: sectionTextColor}">
    <span class="bio-link-simple-icon" v-if="item.icon" :style="{background: sectionTextColor}">
      <v-icon :color="sectionColor">{{ item.icon }}</v-icon>
    </span>
    <div class="bio-link-simple-body" :class="{'bio-link-simple-body-centered': !item.icon}">
      <p v-if="item.title" class="bio-link-simple-title bio-link-title-clamp" :style="{color: sectionTextColor}">{{ item.title }}</p>
      <p v-if="item.description" class="bio-link-simple-desc all-text" :style="{color: sectionTextColor}">{{ item.description }}</p>
      <p v-if="destinationLabel" class="bio-link-destination" :style="{color: sectionTextColor}">{{ destinationLabel }}</p>
    </div>
    <v-icon class="bio-link-simple-arrow" :color="sectionTextColor" size="20">mdi-chevron-right</v-icon>
  </div>
</template>

<script>
export default {
  name: 'SimpleLinkCard',
  props: {
    item: { type: Object, required: true },
    sectionColor: { type: String, default: '#101827' },
    sectionTextColor: { type: String, default: '#FFFFFF' },
    destinationLabel: { type: String, default: null },
  },
}
</script>

<style scoped>
.bio-link-simple {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1rem;
  /* Shared with .bio-link-whatsapp so the two "row" link types read as one
     consistent weight class - a lone one-line title used to render at
     barely 55px, noticeably thinner than its neighbors in the same list. */
  min-height: 4.5rem;
}
.bio-link-simple-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 0.85rem;
  flex-shrink: 0;
}
.bio-link-simple-body {
  flex: 1;
  min-width: 0;
}
.bio-link-simple-body-centered {
  text-align: center;
}
.bio-link-simple-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin: 0;
}
.bio-link-simple-desc {
  font-size: 0.82rem;
  opacity: 0.85;
  margin: 0.15rem 0 0;
}
.bio-link-destination {
  opacity: 0.7;
  font-size: 0.75em;
  margin: 0.1rem 0 0;
}
.bio-link-simple-arrow {
  flex-shrink: 0;
}
.bio-link-title-clamp {
  overflow-wrap: break-word;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal !important;
}
</style>
